export function hasDuplicates(arr: any[]): boolean {
  return new Set(arr).size < arr.length;
}
